var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fixed-btn",class:_vm.fadeClass},[_c('RequestButton',{staticClass:"request",class:_vm.token ? 'login' : 'logout'})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }